export const services = [
  {
    id: 'cleaning',
    name: 'Cleaning',
    icon: 'ri-brush-line',
    description: 'Professional cleaning services',
  },
  {
    id: 'plumbing',
    name: 'Plumbing',
    icon: 'ri-tools-line',
    description: 'Expert plumbing solutions',
  },
  {
    id: 'electrical',
    name: 'Electrical',
    icon: 'ri-flashlight-line',
    description: 'Licensed electrical work',
  },
  {
    id: 'gardening',
    name: 'Gardening',
    icon: 'ri-plant-line',
    description: 'Garden maintenance and landscaping',
  },
  {
    id: 'painting',
    name: 'Painting',
    icon: 'ri-paint-brush-line',
    description: 'Interior and exterior painting',
  },
  {
    id: 'carpentry',
    name: 'Carpentry',
    icon: 'ri-hammer-line',
    description: 'Custom woodwork and repairs',
  },
  {
    id: 'transportation',
    name: 'Transportation',
    icon: 'ri-truck-line',
    description: 'Moving and delivery services',
  },
  {
    id: 'handyman',
    name: 'Handyman',
    icon: 'ri-tools-fill',
    description: 'General repairs and maintenance',
  },
];
